// prompt.js

/*
    user:           user-provided prompt (can be any language, can be very short)
    system:         system-generated prompt used for the generation (derived from the user prompt)
    dual:           whether a model already exists or not (dual because every time the model needs to be considered as well) // TODO move thid out of the prompt?
    quality:        quality of the generated output (i.e., legacy, low, high, or ultra)
    solid:          whether the model should be solid geometry (true) or surface geometry (false)
*/

import QUALITY from '@generio-ai/library-legacy/constants/quality'
import PROMPT from '@/constants/prompt.js'


export class Prompt 
{
    // create new prompt from asset
    static newPromptFromAsset(asset) 
    {
        return new Prompt(
            asset?.additional?.prompt?.user || asset?.additional?.prompt?.positive,
            asset?.additional?.prompt?.system,
            asset?.additional?.prompt?.dual,
            asset?.additional?.prompt?.quality,
            asset?.additional?.prompt?.solid
        )
    }

    // constructor
    constructor(user, system, dual, quality, solid) 
    {
        this.user = user || PROMPT.USER_DEFAULT
        this.system = system || PROMPT.SYSTEM_DEFAULT
        this.dual = dual ?? false
        this.quality = quality || QUALITY.DEFAULT
        this.solid = solid ?? true
    }

    // convert prompt to JSON
    toJSON() 
    {
        return {
            user: this.user,
            system: this.system,
            dual: this.dual,
            quality: this.quality,
            solid: this.solid
        }
    }

    // clone prompt
    clone() {
        return new Prompt(
            this.user,
            this.system,
            this.dual,
            this.quality,
            this.solid
        )
    }
}